module.exports = __webpack_public_path__ + "static/media/YF22_1.199567d1.jpg";